import { LoadingAndErrorRoot } from "./LoadingAndErrorWrapper.styled";
// eslint-disable-next-line import/no-default-export -- deprecated usage
export default LoadingAndErrorRoot;
